export default __webpack_public_path__ + "static/media/PauseWhite.e50059f7.svg";